import Service from '../Service';

export default class Pagination extends Service {
  constructor(cacheCB, onStateUpdate, pageSize) {
    super();
    this.initialize();
    this.__cacheCB = cacheCB;
    onStateUpdate(this.__updatePage);
    this.pageSize = pageSize || 12;
  }
  initialize() {
    this.__currentPageTotal = 0;
    this.page = 0;
  }
  get currentPage() {
    if (!this.initialized) this.page = 1;
    return this.__getCurrentPage();
  }
  get initialized() {
    return this.page > 0;
  }
  getMore() {
    if (this.initialized && !this.showMore) return;
    this.page += 1;
    this.__getCurrentPage();
  }
  get showMore() {
    return this.page * this.pageSize === this.__currentPageTotal;
  }
  __updatePage = () => {
    if (!this.initialized) return;
    this.__getCurrentPage();
    this.emitStateUpdate();
  }
  __getCurrentPage() {
    let _currentPage = [];
    this.allFound = true;
    for (let i = 1; i <= this.page; i += 1) {
      if (this.allFound) {
        const _trees = this.__cacheCB(i);
        if (!_trees) this.allFound = false;
        else _currentPage = [..._currentPage, ..._trees];
      }
    }
    this.__currentPageTotal = _currentPage.length;
    return _currentPage;
  }
}
